import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReceiptComponent } from '@zp-components/receipt/receipt.component';

@Component({
  selector: "app-advice-build-up",
  templateUrl: "./advice-build-up.component.html",
  imports: [TranslateModule, ReceiptComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdviceBuildUpComponent {
  @Output() requestContact = new EventEmitter<void>();
}
